"use strict";

const scrollAnimate = require("./components/scrollAnimate");

/**
 * Validates the gift card input field and updates the UI accordingly.
 *
 * This function checks if the gift card amount field is empty. If it is,
 * it adds an "is-invalid" class to the field and its wrapper, and displays
 * an error message. If the field is not empty, it removes the "is-invalid"
 * class and clears any error messages.
 *
 * @returns {void}
 */
const handleGiftCardValidation = () => {
    const gcFieldWrapper = $(".gc-amount-field");

    if (!gcFieldWrapper.length) {
        return false;
    }

    const gcField = gcFieldWrapper.find(".gc-amount");

    if (!gcField.length) {
        return false;
    }

    const errorMessage = gcField.closest(".form-group").find(".invalid-feedback");
    const fieldValue = gcField.val();
    const minValue = Number(gcField.attr("min"));
    const maxValue = Number(gcField.attr("max"));
    const buttonsWrapper = $(".custom-product-size-wrapper");
    const errorText = gcField.data("error-range");
    let isFieldValueCompleted = true;

    if (fieldValue === "" || fieldValue > maxValue || fieldValue < minValue) {
        isFieldValueCompleted = false;
    }

    if (!isFieldValueCompleted) {
        buttonsWrapper.addClass("is-invalid");
        gcField.addClass("is-invalid");
        gcFieldWrapper.addClass("is-invalid");
        errorMessage.text(errorText);
        scrollAnimate(gcFieldWrapper);
        return false;
    } else {
        buttonsWrapper.removeClass("is-invalid");
        gcField.removeClass("is-invalid");
        gcFieldWrapper.removeClass("is-invalid");
        errorMessage.text("");
    }

    return true;
};

/**
 * Initializes event handlers for gift card amount selection and validation.
 *
 * This function sets up click and change event listeners on gift card amount buttons and input fields.
 * It ensures that the selected amount is reflected correctly in the input field and validates the gift card amount.
 * Additionally, it handles pre-selection of gift card amounts if specified in a modal container.
 *
 * @returns {void}
 */
const initGiftCardEvents = () => {
    const gcField = $(".gc-amount");
    const gcButtons = $(".gc-amount-btn");
    const modalContainer = $(".product-quickview");

    gcButtons.on("click", function () {
        gcField.val($(this).data("amount"));
        gcButtons.removeClass("selected");
        $(this).addClass("selected");
        handleGiftCardValidation();
    });

    gcField.on("change", function () {
        if ($(this).val() !== "") {
            gcButtons.removeClass("selected");
            handleGiftCardValidation();
        }
    });

    gcField.on("keyup", function () {
        gcButtons.removeClass("selected");
    });

    if (modalContainer.length && modalContainer.data("amount-selected") !== "") {
        const buttonToSelect = gcButtons.filter(function () {
            return $(this).data("amount") === Number(modalContainer.data("amount-selected"));
        });

        if (buttonToSelect.length) {
            buttonToSelect.trigger("click");
        }
    }
};

module.exports = {
    handleGiftCardValidation,
    initGiftCardEvents
};
